var _excluded = ["children", "enterTimeout", "exitTimeout"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { ClassNames, keyframes } from "@emotion/core";
import * as React from "react";
import { Transition } from "react-transition-group";
import { jsx as ___EmotionJSX } from "@emotion/core";
var openAnimation = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  from {\n    opacity: 0;\n    transform: translateY(-120%);\n  }\n  to {\n    transform: translateY(0);\n  }\n"])));
var closeAnimation = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  from {\n    transform: scale(1);\n    opacity: 1;\n  }\n  to {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n"])));
var animationEasing = {
  deceleration: "cubic-bezier(0.0, 0.0, 0.2, 1)",
  acceleration: "cubic-bezier(0.4, 0.0, 1, 1)",
  spring: "cubic-bezier(0.175, 0.885, 0.320, 1.175)"
}; // This only measures the height when the component is mounted. This does not
// support measuring after content changes or when the window is resized.

function useInitialHeight() {
  var _React$useState = React.useState(0),
      height = _React$useState[0],
      setHeight = _React$useState[1];

  var measureHeightRef = React.useCallback(function (node) {
    if (node != null) {
      setHeight(node.getBoundingClientRect().height);
    }
  }, []);
  return [height, measureHeightRef];
}

function ToastTransition(_ref) {
  var children = _ref.children,
      enterTimeout = _ref.enterTimeout,
      exitTimeout = _ref.exitTimeout,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useInitialHeight = useInitialHeight(),
      height = _useInitialHeight[0],
      measureHeightRef = _useInitialHeight[1];

  return ___EmotionJSX(Transition, _extends({
    timeout: {
      enter: enterTimeout,
      exit: exitTimeout
    }
  }, props), function (state) {
    return ___EmotionJSX(ClassNames, null, function (_ref2) {
      var cx = _ref2.cx,
          css = _ref2.css;
      var base = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n              height: 0;\n              transition: all ", "ms ", ";\n            "])), exitTimeout, animationEasing.deceleration);
      var transition;

      if (state === "entering" || state === "entered") {
        transition = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n                animation: ", " ", "ms\n                  ", " both;\n              "])), openAnimation, enterTimeout, animationEasing.spring);
      }

      if (state === "exiting") {
        transition = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n                animation: ", " ", "ms\n                  ", " both;\n              "])), closeAnimation, exitTimeout, animationEasing.acceleration);
      }

      return ___EmotionJSX("div", {
        className: cx(base, transition),
        style: {
          height: height
        }
      }, ___EmotionJSX("div", {
        ref: measureHeightRef
      }, children));
    });
  });
}

ToastTransition.defaultProps = {
  "in": false,
  enterTimeout: 250,
  exitTimeout: 100
};
export default ToastTransition;